<div class="payment-widget" [ngClass]="screenClasses()">
  <ng-container [ngSwitch]="screen">

    <ng-container *ngSwitchCase="'init'">
      <ng-container [ngTemplateOutlet]="initRef"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'cards'">
      <ng-container [ngTemplateOutlet]="cardsRef"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'processing'">
      <ng-container [ngTemplateOutlet]="processingRef"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'success'">
      <ng-container [ngTemplateOutlet]="successRef"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'fail'">
      <ng-container [ngTemplateOutlet]="failedRef"></ng-container>
    </ng-container>

  </ng-container>
</div>

<ng-template #initRef>
  <spinner2></spinner2>
</ng-template>

<ng-template #cardsRef>
  <div class="payment-form">
    <div class="payment-top">
      <div class="step-title">
        <div class="title-block">
          <div class="title">{{'meetings.wizard.select-payment' | customLocale}}</div>
          <div *ngIf="paymentProviders?.length"
               class="add-payment-method-link" (clickOutside)="closeAddPaymentMethods()"
               (click)="showAddPaymentMethods()">
            <span class="link">{{'payment-form.payment-method' | customLocale}}</span>
            <ng-template [ngIf]="showAddMethods"
                         [ngIfThen]="addPaymentMethodsRef">
            </ng-template>
          </div>

        </div>
        <div class="payment-systems">
          <app-icon class="icon pci-grey" file="cards" icon="pci-gray"></app-icon>
          <app-icon class="icon mastercard-grey" file="cards" icon="mastercard-gray"></app-icon>
          <app-icon class="icon visa-grey" file="cards" icon="visa-gray"></app-icon>
          <app-icon class="icon mir-grey" file="cards" icon="mir-gray"></app-icon>
        </div>
      </div>
      <div class="top-wrapper">
        <app-payment-widget-payment-method-selector
                                                    [paymentMethods]="paymentMethods" [selectedAccountId]="checkData?.selectedAccountId"
                                                    [paymentProviders]="paymentProviders" [initAdd]="showAddMethods"
                                                    (paymentMethodSelected)="onSelectPaymentMethod($event)"
        ></app-payment-widget-payment-method-selector>
        <app-payment-order [payment]="checkData"></app-payment-order>
      </div>
    </div>
    <div class="not-selected-payment-method-wrap" [class.scroll]="scrollBottom">
      <div class="not-selected-payment-method"  *ngIf="payClicked && !selected">
        {{'payment-form.payment-method-not-selected' | customLocale}}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #processingRef>
  <div class="processing-wrapper" *ngIf="!payment">
    <div class="processing">{{'payment-form.payment-in-progress' | customLocale}}</div>
    <spinner2></spinner2>
  </div>
  <app-payment-widget-merchant-processing
    *ngIf="payment"
    [payment]="payment" [isAccountPayment]="isAccountPayment" [merchant]="merchant"
    (succeed)="onSuccess()"
    (failed)="onFail($event)"
  ></app-payment-widget-merchant-processing>
</ng-template>

<ng-template #successRef>
  <div class="finish-success">
    <div class="title">{{ 'meetings.wizard.pay-success' | customLocale }}</div>
    <app-icon class="icon" width="98" height="98" file="pay" icon="success"></app-icon>
  </div>
</ng-template>

<ng-template #failedRef>
  <div class="finish-fail">
    <div class="title">{{ 'meetings.wizard.pay-fail' | customLocale }}</div>
    <app-icon class="icon" width="98" height="98" file="pay" icon="fail"></app-icon>
    <div class="description">{{errorDescription}}</div>
  </div>
</ng-template>

<ng-template #addPaymentMethodsRef>
  <div class="add-card-list-wrapper" [ngClass]="screenClasses()"
       [class.error]="!paymentMethods.length && payClicked">
    <ng-template [ngIf]="paymentProviders?.length">
      <div class="cards-list">
        <ng-container *ngFor="let provider of paymentProviders; trackBy: trackByFn">
          <div *ngIf="isApprovedProviders(provider)"
               class="card" [class.test]="isTestProvider(provider)"
               [class.selected]="selected?.provider?.id === provider.id"
               (click)="addNewAccount(provider)">

          <div *ngIf="isTestProvider(provider)" class="test-card-label">
              {{'profile-steps.test-provider' | customLocale}}
            </div>

            <ng-template [ngIf]="isForNotRussia(provider)">
          <span class="title normal">
            {{'profile-steps.bank-card-world' | customLocale}} {{isTestProvider(provider) ? '(' + provider?.note + ')' : null}}
          </span>
            </ng-template>
            <ng-template [ngIf]="!isForNotRussia(provider)">
          <span class="title normal">
            {{'profile-steps.bank-card-rus' | customLocale}} {{isTestProvider(provider) ? '(' + provider?.note + ')' : null}}
          </span>
            </ng-template>
            <div class="icons">
              <ng-template [ngIf]="isForNotRussia(provider)">
                <app-icon width="35" height="28" file="cards" icon="master-card"></app-icon>
                <app-icon width="41" height="22" file="cards" icon="visa"></app-icon>
              </ng-template>
              <ng-template [ngIf]="!isForNotRussia(provider)">
                <app-icon width="65" height="15" file="cards" icon="mir"></app-icon>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </div>
</ng-template>
